module.exports = __webpack_public_path__ + "media/footer/fastweb-a-monster-company-339157f7.svg";